module.exports = __webpack_public_path__ + "img/map-placeholder.4edc8cf6.jpg";